import { type Components } from '@tecnobit-srl/components-store';
import {
  type Content,
  type PageProps,
  type Routable,
  type Route,
} from '@tecnobit-srl/types';
import { type CustomFormSubmit } from '@tecnobit-srl/custom-form-submit';
import { type Resource } from 'i18next';

/**
 * Stock frontend variant: core + courses + reviews only.
 *
 * Every variant hook is a no-op / pass-through so the shared client components
 * stay generic. The "tilelook" variant (resolved at build time via the
 * `@variant` alias) provides real implementations. See sites mapping:
 * `SITE -> variant`.
 */

export const useVariantContentTypes = (): Components<Content> => ({});

export const useVariantRouteTypes = (): Components<{ route: Route }> => ({});

export const useVariantRoutableTypes = (): Components<Routable> => ({});

export const useVariantCustomFormSubmits = (): CustomFormSubmit[] => [];

export const VARIANT_RESOURCES: Resource = {};

export const useVariantBreadcrumbs = (
  page: PageProps
): PageProps['route']['breadcrumbs'] => page.route.breadcrumbs;

export const useVariantSeo = <T,>(_pageProps: PageProps, base: T): T => base;
